import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

type Ratio = number; // 0.0 .. 1.0

const DEFAULT_SHRINK_RATIO = 0.95;
const INTERVAL = 1000;

type Props = {
  className?: string;
  style?: React.CSSProperties;
  ratio: Ratio;
  ratioUpTo?: Ratio;
  shrinkRatio?: Ratio;
};

export default function ProgressBar({
  className,
  style,
  ratio,
  ratioUpTo = ratio,
  shrinkRatio = DEFAULT_SHRINK_RATIO,
}: Props) {
  const [actualRatio, setActualRatio] = React.useState(ratio);

  React.useEffect(() => {
    setActualRatio((value) => Math.min(ratioUpTo, Math.max(ratio, value)));

    const intervalId = setInterval(() => {
      setActualRatio((value) => ratioUpTo - (ratioUpTo - value) * shrinkRatio);
    }, INTERVAL);

    return () => clearInterval(intervalId);
  }, [ratio, ratioUpTo, shrinkRatio]);

  return (
    <div className={cx(styles.container, className)} style={style}>
      <div
        className={styles.completedRectangle}
        style={{
          transform: `translateX(${(actualRatio - 1) * 100}%)`,
        }}
      ></div>
    </div>
  );
}
